export const GET_CLICKS_DASHBOARD_STICKY_COLUMNS = "GET_CLICKS_DASHBOARD_STICKY_COLUMNS";
export const GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS = "GET_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR = "GET_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR";

export const UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS = "UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS";
export const UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS = "UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_SUCCESS";
export const UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR = "UPDATE_CLICKS_DASHBOARD_STICKY_COLUMNS_ERROR";